/**
 * CollabV3Avatar 컴포넌트
 * @description 사람 얼굴 — 사진이 있으면 사진, 없으면 이름 첫 글자. 조직 명의 주최자는 사각이다
 *   (앱 `CollabPersonAvatar`).
 * @example <CollabV3Avatar person={organizer} size="sm" isSquare={organizer.isSquare} />
 */
import { Avatar } from "@fanwork-web/design-system";
import { memo } from "react";

import { COLLAB_V3_AVATAR_WIDTH } from "./CollabV3Detail.styles";
import type { CollabV3AvatarProps } from "./CollabV3Detail.types";

import { AppImage } from "@/shared/ui";

const CollabV3Avatar = memo<CollabV3AvatarProps>(
  ({ person, size, isSquare = false }) => {
    const radius = isSquare ? "square" : "circle";
    if (!person.avatarUrl) {
      return (
        <Avatar
          type="initial"
          size={size}
          radius={radius}
          initial={person.name.charAt(0).toUpperCase()}
        />
      );
    }
    return (
      <Avatar
        type="image"
        size={size}
        radius={radius}
        image={
          <AppImage
            uri={person.avatarUrl}
            targetWidth={COLLAB_V3_AVATAR_WIDTH[size]}
          />
        }
      />
    );
  },
);

CollabV3Avatar.displayName = "CollabV3Avatar";

export default CollabV3Avatar;
